import { useContext, useEffect } from "react";
import { ContextNav, ContextDashboard, ContextLoading } from "../../context";
import { ActiveUserChart, CSkeletonDashboard, StatusChart } from "../../components/widget";
import { Link , useNavigate} from "react-router-dom";

export const Dashboard = () => {
    const navigate = useNavigate();
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)

    useEffect(() => {
        document.title = "داشبورد | دایان"
        CtxNav.setActiveMenuItem({ 'item': 0, 'subItem': 0, })
    }, [])

    return (
        <div className=" w-full flex flex-col">

            <div className=" w-full flex md:flex-row flex-col justify-between">
                <div className="w-full md:w-[calc(100%-210px)] h-[35px] md:h-[50px] shadow bg-dayan-gray-80 rounded overflow-hidden md:rounded-lg flex items-center  px-[10px] text-white text-sm">
                    <span>{CtxDash.profile?.name} </span>
                </div>
                <div className="w-full md:w-[200px] h-[35px] md:h-[50px] shadow md:mt-0 mt-[10px] bg-white  overflow-hidden rounded md:rounded-lg text-[11px] flex justify-center items-center">امروز {new Date().toLocaleDateString('fa-Ir')} </div>
            </div>

            {CtxLoad.displayLoadingSkelton == false ?
                <>
                    <div className="w-full  mt-[30px] flex flex-col">
                        <div className=" w-full h-[30px] flex items-center">
                            <svg x="0px" y="0px" viewBox="0 0 459.863 459.863" className={`  h-6 fill-dayan-gray-200 `}>
                                <use xlinkHref="/assetes/svg/users.svg#users" />
                            </svg>
                            <span className="text-sm mr-[10px]">وضعیت پرسنل</span>
                        </div>
                        <div className="w-full flex flex-wrap mt-[10px]">
                            <div className=" w-[50%] md:w-[24%] pl-1 md:pl-2 order-1 ">
                                <div onClick={()=>{navigate('/p/users')}} className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow px-[20px] py-[30px] flex flex-col justify-between items-center relative cursor-pointer dashboard-hover">
                                    <span className=" text-sm text-center">تعداد کل پرسنل</span>
                                    <div className=" w-[40px] h-[40px]  bg-dayan-gray-80 rounded-full flex justify-center items-center text-sm text-white">{CtxDash.dashboard?.personel_count}</div>
                                    <div className=" w-full flex  justify-end absolute bottom-3 left-3">
                                        <img src='/assetes/svg/fullscreen.svg' className="w-[30px] cursor-pointer" />
                                    </div>
                                </div>
                            </div>
                            <div className="w-full md:w-[38%] px-0 md:px-1 order-3 md:order-2  md:mt-0 mt-2">
                                <div onClick={()=>{navigate('/p/reports/rollcall')}} className=" w-full h-[170px] md:h-[190px] p-[20px] bg-white rounded-lg shadow flex justify-center items-center cursor-pointer dashboard-hover">
                                    {CtxDash.dashboard != null &&
                                        <ActiveUserChart count={CtxDash.dashboard?.active_personel} />
                                    }
                                </div>
                            </div>
                            <div className="w-[50%] md:w-[38%] pr-1 md:pr-2 order-2 md:order-3 overflow-hidden">
                                <div  className=" w-full h-[170px] md:h-[190px] p-[20px] pb-[25px] bg-white rounded-lg shadow flex justify-center items-center dashboard-hover">
                                    {CtxDash.dashboard != null &&
                                        <StatusChart chartData={CtxDash.dashboard?.chart_data} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" w-full flex items-center flex-wrap">
                        <div className=" w-full md:w-6/12 pl-0 md:pl-2">
                            <div className="w-full  mt-[30px] flex flex-col">
                                <div className=" w-full h-[30px] flex items-center">
                                    <svg x="0px" y="0px" viewBox="0 0 446 446" className={`  h-6 fill-dayan-gray-200 `}>
                                        <use xlinkHref="/assetes/svg/clock.svg#clock" />
                                    </svg>
                                    <span className="text-sm mr-[10px]">تاخیرها</span>
                                </div>
                                <div className="w-full flex flex-wrap mt-[10px]">

                                    <div className=" w-[50%]  pl-[5px]  ">
                                        <div onClick={()=>{navigate('/p/reports/delay')}} className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow px-[20px] py-[30px] flex flex-col justify-between items-center cursor-pointer relative dashboard-hover">
                                            <span className=" text-sm text-center">تاخیر های امروز</span>
                                            <div className=" w-[40px] h-[40px]  bg-dayan-orange-50 rounded-full flex justify-center items-center text-sm text-white ">{CtxDash.dashboard?.personel_with_delay}</div>
                                            <div className=" w-full flex justify-end absolute bottom-3 left-3">
                                                <Link to='/p/reports/delay'>
                                                    <img src='/assetes/svg/fullscreen.svg' className="w-[30px] cursor-pointer" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className=" w-[50%]  pr-[5px]  ">
                                        <div onClick={()=>{navigate('/p/reports/delay?status=0')}} className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow px-[20px] py-[30px] flex flex-col justify-between items-center cursor-pointer relative dashboard-hover">
                                            <span className=" text-sm text-center">تاخیر های بررسی نشده</span>
                                            <div className=" w-[40px] h-[40px]  bg-dayan-gray-80 rounded-full flex justify-center items-center text-sm text-white">{CtxDash.dashboard?.pending_delay}</div>
                                            <div className=" w-full flex justify-end absolute bottom-3 left-3">
                                                <Link to='/p/reports/delay'>
                                                    <img src='/assetes/svg/fullscreen.svg' className="w-[30px] cursor-pointer" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" w-full md:w-6/12 pl-0 md:pl-2">
                            <div className="w-full  mt-[30px] flex flex-col">
                                <div className=" w-full h-[30px] flex items-center">
                                    <svg x="0px" y="0px" viewBox="0 0 455 455" className={`  h-6 fill-dayan-gray-200 `}>
                                        <use xlinkHref="/assetes/svg/moon.svg#moon" />
                                    </svg>
                                    <span className="text-sm mr-[10px]">مرخصی ها</span>
                                </div>
                                <div className="w-full flex flex-wrap mt-[10px]">
                                    <div className=" w-[50%]  pl-[5px]  ">
                                        <div onClick={()=>{navigate('/p/reports/vacation?status=1')}} className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow px-[20px] py-[30px] flex flex-col justify-between items-center cursor-pointer relative dashboard-hover">
                                            <span className=" text-sm text-center">مرخصی های تایید شده امروز</span>
                                            <div className=" w-[40px] h-[40px]  bg-dayan-orange-50 rounded-full flex justify-center items-center text-sm text-white">{CtxDash.dashboard?.approved_vacation}</div>
                                            <div className=" w-full flex justify-end absolute bottom-3 left-3">
                                                <Link to='/p/reports/vacation'>
                                                    <img src='/assetes/svg/fullscreen.svg' className="w-[30px] cursor-pointer" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" w-[50%]  pr-[5px]  ">
                                        <div onClick={()=>{navigate('/p/reports/vacation?status=0')}} className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow px-[20px] py-[30px] flex flex-col justify-between items-center cursor-pointer relative dashboard-hover">
                                            <span className=" text-sm text-center">مرخصی های بررسی نشده</span>
                                            <div className=" w-[40px] h-[40px]  bg-dayan-gray-80 rounded-full flex justify-center items-center text-sm text-white">{CtxDash.dashboard?.pending_vacation}</div>
                                            <div className=" w-full flex justify-end absolute bottom-3 left-3">
                                                <Link to='/p/reports/vacation'>
                                                    <img src='/assetes/svg/fullscreen.svg' className="w-[30px] cursor-pointer" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" w-full flex items-center flex-wrap">
                        <div className=" w-full md:w-6/12 pl-0 md:pl-2">
                            <div className="w-full  mt-[30px] flex flex-col">
                                <div className=" w-full h-[30px] flex items-center">
                                    <svg x="0px" y="0px" viewBox="0 0 446 446" className={`  h-6 fill-dayan-gray-200 `}>
                                        <use xlinkHref="/assetes/svg/clock.svg#clock" />
                                    </svg>
                                    <span className="text-sm mr-[10px]">اضافه کاری ها</span>
                                </div>
                                <div className="w-full flex flex-wrap mt-[10px]">
                                    <div className=" w-[50%]  pl-[5px]  ">
                                        <div onClick={()=>{navigate('/p/reports/overtime?status=0')}} className=" w-full h-[170px] md:h-[190px] bg-white rounded-lg shadow px-[20px] py-[30px] flex flex-col justify-between items-center cursor-pointer relative dashboard-hover">
                                            <span className=" text-sm text-center">اضافه‌کاری‌های بررسی نشده</span>
                                            <div className=" w-[40px] h-[40px]  bg-dayan-gray-80 rounded-full flex justify-center items-center text-sm text-white">{CtxDash.dashboard?.pending_overtime}</div>
                                            <div className=" w-full flex justify-end absolute bottom-3 left-3">
                                                <img src='/assetes/svg/fullscreen.svg' className="w-[30px] cursor-pointer" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                :
                <CSkeletonDashboard />
            }
        </div>
    )
}